
function Pricing() {
    return (
      <div>Цены</div>
    );
  }
  
  export default Pricing;